import { InitialState } from "./type";

export const initialState: InitialState = {
  ordersList: [],
  orderDetail: {},
  getAllOrders: {},
  getOrderList: {},
  toast: false,
};
